// src/Components/utils/constants.js
export const EAIM_PURPLE = "#6C2BD9";
export const EAIM_PINK   = "#E34AB5";
export const EAIM_GREEN  = "#2D9966";
export const EAIM_ORANGE = "#FF8A00";
export const SOFT_GREY   = "#F4F6F6";
export const EAIM_BLUE = "#250ad5ff";
export const CARD_GREY   = "#D9D9D9";
export const TEXT_DARK   = "#27323A";
export const DARK_BG   = "#2c2c2c";
export const DARK_CARD   = "#2f2f2f";
export const TEXT_WHITE   = "#F4F6F6";
